<template>
    <Wrapper>
        <div class="flex-fill">
            <div class="row mt-1 wow fadeInUp" data-wow-delay=".3s">
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Health</h5>
                                <h3 class="text-nowrap">99.3%</h3>
                            </div>
                            <div class="col bg-primary d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="#" class="nav-link text-white pb-0" title="View details"><span class="d-inline-block lnr lnr-heart"></span></a></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Cycles</h5>
                                <h3>53</h3></div>
                            <div class="col bg-primary d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="#" class="nav-link text-white pb-0" title="View details"><span class="d-inline-block lnr lnr-history"></span></a></h1></div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Storage</h5>
                                <h3 class="text-nowrap">69%</h3>
                            </div>
                            <div class="col bg-primary d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="#" class="nav-link text-white pb-0" title="View details"><span class="d-inline-block lnr lnr-database"></span></a></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl col-sm-6 pb-3">
                    <div class="card d-block p-1 h-100 shadow-sm">
                        <div class="row h-100 no-gutters">
                            <div class="col-6 p-3 py-4">
                                <h5 class="text-truncate">Signal</h5>
                                <h3>4.1</h3></div>
                            <div class="col bg-primary d-flex">
                                <h1 class="mb-0 mx-auto align-self-center"><a href="#" class="nav-link text-white pb-0" title="View details"><i class="lnr lnr-heart-pulse"></i></a></h1></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row wow fadeInUp" data-wow-delay=".5s">
                <div class="col-xl-3 col-lg-12 py-3 wow fadeInUp" data-wow-delay=".5s">
                    <CardDevices />
                </div>
                <div class="col-xl-3 col-lg-12 py-3 wow fadeInUp" data-wow-delay="1s">
                    <CardActivity />
                </div>
                <div class="col-xl-6 col-lg-12 py-3">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body p-3 d-flex flex-column">
                            <h4 class="font-weight-light mb-3">Visits</h4>
                            <span class="text-center text-muted small">Unique daily visitors in the last week</span>
                            <div class="mt-auto py-1">
                                <LineChart height="300" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span class="anchor" id="snapshot"></span>
            <section class="row mt-2">
                <div class="col-xl py-3">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body">
                            <div class="h4 m-0">
                                <i class="float-right lnr lnr-cloud-sync"></i>
                                Latest Build v1.1.6
                            </div>
                            <div>75% complete</div>
                            <div class="progress my-3">
                                <div role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-primary w-75"></div>
                            </div> <small class="text-muted"><a href="#modalSmall" data-toggle="modal">View build log</a></small></div>
                    </div>
                </div>
                <div class="col-xl py-3">
                    <div class="card h-100 shadow-sm">
                        <div class="card-body">
                            <div class="h4 m-0">
                                <i class="float-right lnr lnr-database"></i>
                                24 GB
                            </div>
                            <div>Backup in progress...</div>
                            <div class="progress my-3">
                                <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-dark w-25"></div>
                            </div> <small class="text-muted">Contact the administrator for reports.</small></div>
                    </div>
                </div>
            </section>
            <section class="row">
                <div class="col-xl-4 col-sm-6 py-3">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <h4 class="font-weight-light">
                                <div class="float-right dropdown"><button data-toggle="dropdown" class="btn btn-link text-dark p-0 dropdown-toggle"><i class="lnr lnr-cog"></i></button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <button class="dropdown-item">Action</button>
                                        <button class="dropdown-item">Another action</button>
                                    </div>
                                </div>
                                Framework
                            </h4>
                            <DonutChart ref="donutChart1" class="mt-3 mx-auto" />
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-6 py-3">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <h4 class="font-weight-light">
                                <div class="float-right dropdown"><button data-toggle="dropdown" class="btn btn-link text-dark p-0 dropdown-toggle"><i class="lnr lnr-cog"></i></button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <button class="dropdown-item">Action</button>
                                        <button class="dropdown-item">Another action</button>
                                    </div>
                                </div>
                                Games
                            </h4>
                            <DonutChart ref="donutChart2" :data="dataDonut2" class="mt-3 mx-auto" />
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-6 py-3 mx-auto">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <h4 class="font-weight-light">
                                <div class="float-right dropdown"><button data-toggle="dropdown" class="btn btn-link text-dark p-0 dropdown-toggle"><i class="lnr lnr-cog"></i></button>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <button class="dropdown-item">Action</button>
                                        <button class="dropdown-item">Another action</button>
                                    </div>
                                </div> 
                                Stack
                            </h4>
                            <DonutChart ref="donutChart3" :data="dataDonut3" class="mt-3 mx-auto" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="row">
                <div class="col py-3">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <div>
                                <div class="card border-light my-2">
                                    <div class="card-body">
                                        <span class="float-right text-muted small">11.12.2019T8:02:10.35Z</span>
                                        <h5 class="card-title"><span class="badge badge-pill bg-warning">&nbsp;</span> Vuedoo</h5>
                                        <p class="card-text">The process completed, but the write disk is at 10% remaining. <button class="btn btn-sm btn-outline-warning align-bottom ml-3">Details</button></p>
                                    </div>
                                </div>
                                <div class="card border-light my-2">
                                    <div class="card-body">
                                        <span class="float-right text-muted small">11.12.2019T8:00:20.10Z</span>
                                        <h5 class="card-title"><span class="badge badge-pill bg-success">&nbsp;</span> Esque</h5>
                                        <p class="card-text">The process completed successfully.</p>
                                    </div>
                                </div>
                                <div class="card border-light my-2">
                                    <div class="card-body">
                                        <span class="float-right text-muted small">11.12.2019T7:59:33.12Z</span>
                                        <h5 class="card-title"><span class="badge badge-pill bg-success">&nbsp;</span> Nachure</h5>
                                        <p class="card-text">The process completed successfully.</p>
                                    </div>
                                </div>
                                <div class="card border-light my-2">
                                    <div class="card-body">
                                        <span class="float-right text-muted small">11.12.2019T7:57:04.13Z</span>
                                        <h5 class="card-title"><span class="badge badge-pill bg-danger">&nbsp;</span> Admine</h5>
                                        <p class="card-text">The process completed, but an error occured. <button class="btn btn-sm btn-outline-danger align-bottom ml-3">Details</button></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="row">
                <div class="col py-3">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <DataTable></DataTable>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper, LineChart, DonutChart, CardDevices, CardActivity, DataTable } from '../../components';

export default {
    components: {
        Wrapper,
        LineChart, 
        DonutChart, 
        CardDevices, 
        CardActivity, 
        DataTable
    },
    data() {
        return {
            dataDonut2: {
                "labels": ["Hip", "Hop", "Hat"],
                "datasets": [{
                    "borderWidth": 0,
                    "data": [10, 20, 60]
                }]
            },
            dataDonut3: {
                "labels": ["Run", "Pass", "Catch"],
                "datasets": [{
                    "backgroundColor": ["red","pink","lime"],
                    "borderWidth": 0,
                    "data": [10, 70, 5]
                }]
            }
        }
    }
};
</script>
